export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const PROFILE_PIC = 'PROFILE_PIC'
